import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { BenefitUseInputVariables, BenefitUseInputArgs } from './queryVariables/benefitUseInput';
/**
 *  Resource użytych usług
 *
 * @export
 * @class BenefitUseResource
 * @extends {EntityResource<BenefitUse>}
 */
export class BenefitUseResource extends EntityResource {
    constructor() {
        super({
            entityName: 'benefitUse',
            listName: 'benefitUsages'
        });
        this.getFields = {
            id: true,
            created: true,
            modified: true,
            price: true,
            value: true,
            profile: { id: true },
            benefit: { id: true, name: true }
        };
        this.listFields = {
            id: true,
            created: true,
            price: true,
            value: true,
            benefit: {
                id: true,
                name: true,
                type: true,
                value: true
            },
            place: {
                name: true
            },
            card: {
                number: true
            },
            profile: {
                id: true,
                userId: true,
                firstName: true,
                lastName: true
            }
        };
        this.addVariables = { ...BenefitUseInputVariables };
        this.addArgs = { ...BenefitUseInputArgs };
        this.updateVariables = { id: 'Int!', ...BenefitUseInputVariables };
        this.updateArgs = { id: new VariableType('id'), ...BenefitUseInputArgs };
        this.listVariables = { filters: 'BenefitUseFilters' };
    }
}
export const benefitUseResource = new BenefitUseResource();
//# sourceMappingURL=benefitUse.resource.js.map